import * as React from 'react';
import Popup from '../Popup';

export type Props = {
    showPopup: boolean;
    onClose: () => void;
};

type State = {
    firstLoading: boolean;
};

class PopupMobileWarning extends React.Component<Props, State> {
    private comPopup: Popup;

    constructor(props: Props) {
        super(props);
        this.state = {
            firstLoading: true
        };
    }

    componentDidMount() {
        if (this.props.showPopup) {
            this.comPopup.open();
        }
    }

    componentWillReceiveProps(nextProps: Props) {
        if (nextProps.showPopup !== this.props.showPopup) {
            if (nextProps.showPopup) {
                this.comPopup.open();
            } else {
                this.comPopup.close();
                this.setState({ firstLoading: true });
            }
        }
    }

    onClosePopup = () => {
        this.props.onClose();
    }

    render() {
        return (
            <Popup
                ref={com => this.comPopup = com!}
                title="Registration Not Supported on Mobile Devices"
                close={this.onClosePopup}
                popupHidden={this.onClosePopup}
                extendClass=""
                footer={
                    <button
                        type="button"
                        className="btn btn-sm btn-light"
                        onClick={this.onClosePopup}
                    >
                        OK
                    </button>
                }
            >
                <div className="form-group row">
                    <span className="col-auto col-form-label" style={{ color: '#333' }}>
                        To begin your registration, please switch to a laptop or desktop browser.
                        <br /><br />
                        This feature is not currently supported on mobile devices.
                    </span>
                </div>
            </Popup>
        );
    }
}

export default PopupMobileWarning;



// WEBPACK FOOTER //
// ./src/components/shared/PopupMobileWarning/PopupMobileWarning.tsx